import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import TwoFactorPopupViewModel from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopupViewModel';
import TwoFactorPopup from '@/Components/TwoFaktorAuth/PopupWindow/TwoFactorPopup';
import {ITwoFactorPopupViewFactoryConstructorParameter, ITwoFactorPopupViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

/**
 * Window-Komponente, welche den 2FA in einem Fenster anzeigt
 */
export default class TwoFactorPopupViewFactory extends ViewFactory {
    private TwoFactorPopupViewModel = ComponentManager.getViewModel<typeof TwoFactorPopupViewModel>('TwoFactorPopupViewModel');
    private TwoFactorPopup = ComponentManager.getControl<typeof TwoFactorPopup>('TwoFactorPopup');
    private onClose: () => void;

    private userName: string;
    private surAndLastname: string;

    public viewModel: TwoFactorPopupViewModel;
    public twoFAPopUpView: TwoFactorPopup;

    public constructor(params: ITwoFactorPopupViewFactoryConstructorParameter) {
        super(params);

        this.userName = this.paramOrDefault(params.userName, null);
        this.surAndLastname = this.paramOrDefault(params.surAndLastname, null);
        this.onClose = this.handlerOrDefault(params.onClose);
    }

    public getRegion(): string {
        return 'Modal';
    }

    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel(this.createViewModelParameter());
        }

        if (this.twoFAPopUpView == null) {
            this.twoFAPopUpView = this.createView(this.viewModel);
        }

        const tuple = this.twoFAPopUpView.getTuple();
        return tuple.control;
    }

    protected createViewModelParameter(): ITwoFactorPopupViewModelConstructorParameter {
        return {
            userName: this.userName,
            surAndLastname: this.surAndLastname,
            onClose: this.onClose
        };
    }

    protected createViewModel(parameter: ITwoFactorPopupViewModelConstructorParameter): TwoFactorPopupViewModel {
        return new this.TwoFactorPopupViewModel(parameter);
    }

    protected createView(viewModel: TwoFactorPopupViewModel): TwoFactorPopup {
        return new this.TwoFactorPopup(viewModel);
    }
}

ComponentManager.setFactory('TwoFactorPopupView', TwoFactorPopupViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');